import * as React from 'react'
import { IMaskInput } from 'react-imask'
import Box from '@mui/material/Box'
import Input from '@mui/material/Input'
import InputLabel from '@mui/material/InputLabel'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import InputAdornment from '@mui/material/InputAdornment'

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void
    name: string
}

const TextMaskCustom = React.forwardRef<HTMLElement, CustomProps>(

    function TextMaskCustom(props, ref) {
        const [mask, setMask] = React.useState("XX #### XX")

        const constructCarNumberMask = (input: string) => {
            // Remove any non-alphanumeric characters and convert to uppercase
            const cleanedInput = input.replace(/[^A-Z0-9]/g, '').toUpperCase()

            // Determine the mask format based on the input
            let mask = ''

            const hasOneLeadingNumber = cleanedInput.slice(0, 2).replace(/[^A-Z]/gi, '').toUpperCase().length
            
            if (hasOneLeadingNumber == 1) {
                // "X #### XX" format (e.g., "A 9999 AA" or "B 1234 CD")
                mask = 'X #### XX'
            } else if (hasOneLeadingNumber == 2) {
                // "XX #### XX" format (e.g., "AA 9999 AA" or "BT 1234 BT")
                mask = 'XX #### XX'
            } else {
                // Default mask (e.g., when no format matches)
                mask = 'X #### XX' // You can set a default mask here
            }
            // Set the mask using the global setMask function
            setMask(mask)
        }


        const { onChange, ...other } = props
        return (
            <IMaskInput
                {...other}
                mask={mask}
                definitions={{
                    '#': /[a-zA-Z0-9]/,
                    'X': /[a-zA-Z]/
                }}
                inputRef={(ref as any)}
                onAccept={(value: any) => {
                    constructCarNumberMask(value.toUpperCase())
                    onChange({ target: { name: props.name, value: value.toUpperCase() } })
                }}
                overwrite
            />
        )
    },
)

type CarNumberTextFieldProps = {
    value: string,
    setValue: (value: string) => void,
    hasError: boolean,
    disabled: boolean
}

const CarNumberTextField = (props: CarNumberTextFieldProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.setValue(event.target.value)
    }

    return (

        <FormControl variant="outlined">
            <TextField
                disabled={props.disabled}
                label="Номер на кола"
                autoFocus
                InputProps={{
                    inputComponent: TextMaskCustom as any,
                    // startAdornment: <InputAdornment position="start">+359</InputAdornment>
                }}
                error={props.hasError}
                value={props.value}
                onChange={handleChange}
                name="carNumber-textmask"
                size="small"
                id="carNumber" />
        </FormControl>
    )
}

export default CarNumberTextField